<app-navigation></app-navigation>
<div class="router-output" [ngClass]="{'custom-hidden': loading}">
  <router-outlet></router-outlet>
</div>


<div class="loader" [ngClass]="{'custom-hidden': !loading}"  style="height: 100vh;">
  <div class="casinoRoyaleLoader">
    <div class="loaderBall"></div>
    <div class="loaderShadow"></div>
  </div>
</div>
<app-add-funds-modal></app-add-funds-modal>
